/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SalesCompany,
  SalesCompanySearchResult,
  SchemaValidationErrorResponse,
  SearchSalesCompaniesParams,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Search companies for the sales request wizard
 */
export const searchSalesCompanies = (
    params?: MaybeRefOrGetter<SearchSalesCompaniesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SalesCompanySearchResult[]>(
      {url: `/sales/companies`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchSalesCompaniesQueryKey = (params?: MaybeRefOrGetter<SearchSalesCompaniesParams>,) => {
    return [
    'sales','companies', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchSalesCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof searchSalesCompanies>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<SearchSalesCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSalesCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchSalesCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSalesCompanies>>> = ({ signal }) => searchSalesCompanies(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchSalesCompanies>>, TError, TData>
}

export type SearchSalesCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof searchSalesCompanies>>>
export type SearchSalesCompaniesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search companies for the sales request wizard
 */

export function useSearchSalesCompanies<TData = Awaited<ReturnType<typeof searchSalesCompanies>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<SearchSalesCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSalesCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchSalesCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get company data for prefilling the school step
 */
export const getSalesCompany = (
    publicId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      publicId = toValue(publicId);

      return axiosClient<SalesCompany>(
      {url: `/sales/companies/${publicId}`, method: 'GET', signal
    },
      );
    }




export const getGetSalesCompanyQueryKey = (publicId: MaybeRefOrGetter<string>,) => {
    return [
    'sales','companies',publicId
    ] as const;
    }


export const getGetSalesCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getSalesCompany>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(publicId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSalesCompanyQueryKey(publicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesCompany>>> = ({ signal }) => getSalesCompany(publicId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(publicId) !== null && toValue(publicId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesCompany>>, TError, TData>
}

export type GetSalesCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesCompany>>>
export type GetSalesCompanyQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get company data for prefilling the school step
 */

export function useGetSalesCompany<TData = Awaited<ReturnType<typeof getSalesCompany>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 publicId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSalesCompanyQueryOptions(publicId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






